<template>
  <div>
    <h1 style="text-align: center">助教科技平台服务协议</h1>

    <span style="font-size:16px;float:right;margin-top: 5px">更新日期：2024年12月31日</span>


    <h4 style="margin-top: 5px">提示条款</h4>

    欢迎您与各助教科技平台经营者（详见定义条款）共同签署本《助教科技平台服务协议》（下称“本协议”）并使用助教科技平台服务！<br>

    本协议为《助教科技服务协议》修订版本，自本协议发布之日起，助教科技平台各处所称“助教科技服务协议”均指本协议。<br>

    各服务条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。<br>

    【审慎阅读】您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如您对协议有任何疑问，可向助教科技平台客服咨询。<br>

    【签约动作】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与助教科技达成一致，成为助教科技平台“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。<br>


    一、定义<br>

    助教科技平台：指包括助教科技网（域名为 zhuxikeji.cn）网站及客户端。<br>

    助教科技：助教科技平台经营者的单称或合称，包括助教科技网经营者助教科技有限公司等。<br>

    助教科技平台服务：助教科技基于互联网，以包含助教科技平台网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。<br>

    助教科技平台规则：包括在所有助教科技平台规则频道内已经发布及后续发布的全部规则、解读、公告等内容以及各平台在帮派、论坛、帮助中心内发布的各类规则、实施细则、产品流程说明、公告等。<br>

    助教科技网规则：助教科技网规则频道列明的各项规则，详见此处。<br>


    二、协议范围<br>

    2.1 签约主体<br>

    【平等主体】本协议由您与助教科技平台经营者共同缔结，本协议对您与助教科技平台经营者均具有合同效力。<br>

    【主体信息】助教科技平台经营者是指经营助教科技平台的各法律主体，您可随时查看助教科技平台各网站首页底部公示的证照信息以确定与您履约的助教科技主体。本协议项下，助教科技平台经营者可能根据助教科技平台的业务调整而发生变更，变更后的助教科技平台经营者与您共同履行本协议并向您提供服务，助教科技平台经营者的变更不会影响您本协议项下的权益。助教科技平台经营者还有可能因为提供新的助教科技平台服务而新增，如您使用新增的助教科技平台服务的，视为您同意新增的助教科技平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。<br>

    2.2 补充协议<br>

    由于互联网高速发展，您与助教科技签署的本协议列明的条款并不能完整罗列并覆盖您与助教科技所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，助教科技平台法律声明及隐私政策、助教科技平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用助教科技平台服务，视为您同意上述补充协议。<br>


    三、账户注册与使用<br>

    3.1 用户资格<br>

    您确认，在您开始注册程序使用助教科技平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。<br>

    此外，您还需确保您不是任何国家、地区或国际组织实施的贸易限制、经济制裁或其他法律法规限制的对象，也未直接或间接为前述对象提供资金、商品或服务，否则您应当停止使用助教科技平台服务，同时，您理解违反前述要求可能会造成您无法正常注册及使用助教科技平台服务。<br>

    3.2 账户说明<br>

    【账户获得】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得助教科技平台账户并成为助教科技平台用户。<br>

    助教科技平台只允许每位用户使用一个助教科技平台账户。如有证据证明或助教科技根据助教科技平台规则判断您存在不当注册或不当使用多个助教科技平台账户的情形，助教科技平台可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给助教科技平台及相关方造成损失的，您还应承担赔偿责任。<br>

    【账户使用】您有权使用您设置或确认的助教科技会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录助教科技平台。<br>

    您有权使用您的助教科技平台账户登录阿里平台，但您的助教科技平台账户于2013年3月18日前注册或者您注册助教科技平台账户时所使用的邮箱或手机号码已在阿里平台注册或使用过的除外。<br>

    由于您的助教科技平台账户关联您的个人信息及助教科技平台商业信息，您的助教科技平台账户仅限您本人使用。未经助教科技平台同意，您直接或间接授权第三方使用您助教科技平台账户或获取您账户项下信息的行为无效。如助教科技根据助教科技平台规则中约定的违约认定程序及标准判断您助教科技平台账户的使用可能危及您的账户安全及/或助教科技平台信息安全的，助教科技平台可拒绝提供相应服务或终止本协议。<br>

    【账户转让】由于用户账户关联用户信用信息，仅当有法律明文规定、司法裁定或经助教科技同意，并符合助教科技平台规则规定的用户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则助教科技平台有权追究您的违约责任，且由此产生的责任及后果均由您自行承担。<br>

    【实名认证】作为助教科技平台经营者，为使您更好地使用助教科技平台的各项服务，保障您的账户安全，助教科技可要求您按公司要求及相关法律法规规定完成实名认证。<br>

    【不活跃账户回收】如您的账户同时符合以下条件，则助教科技可回收您的账户，您的账户将不能再登录任一助教科技平台，相应服务同时终止：<br>

    （一）未绑定通过实名认证的账户；<br>

    （二）连续六个月未用于登录任一平台；<br>

    （三）不存在未到期的有效业务。<br>

    3.3 注册信息管理<br>

    3.3.1 真实合法<br>

    【信息真实】在使用助教科技平台服务时，您应当按助教科技平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便助教科技或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。<br>

    【会员名的合法性】您设置的助教科技会员名不得违反国家法律法规及助教科技平台相关规则关于会员名的管理规定，否则助教科技可回收您的助教科技会员名。助教科技会员名的回收不影响您以邮箱、手机号码登录助教科技平台并使用助教科技平台服务。<br>

    3.3.2 更新维护<br>

    您应当及时更新您提供的信息，在法律有明确规定要求助教科技作为平台服务提供者必须对部分用户（如平台卖家等）的信息进行核实的情况下，助教科技将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。<br>

    如助教科技按您最后一次提供的信息与您联系未果、您未按助教科技的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及助教科技造成的全部损失与不利后果。助教科技可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部助教科技平台服务，助教科技对此不承担责任。<br>

    3.4 账户安全规范<br>

    【账户安全保管义务】您的账户为您自行设置并由您保管，助教科技任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开助教科技平台。<br>

    账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，助教科技并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。<br>

    【账户行为责任自负】除助教科技存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。<br>

    【日常维护须知】如发现任何未经授权使用您账户登录助教科技平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知助教科技。您理解助教科技对您的任何请求采取行动均需要合理时间，且助教科技应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除助教科技存在法定过错外，助教科技不承担责任。<br>


    四、助教科技平台服务及规范<br>

    【服务概况】您有权在助教科技平台上享受商品及/或服务的浏览、收藏、购买与评价、交易争议处理、信息交流如问答及分享等服务。助教科技提供的服务内容众多，具体您可登录助教科技平台浏览。<br>

    4.1 商品及/或服务的浏览、收藏<br>

    在您浏览我们网站或客户端的过程中，助教科技为您提供了信息分类、关键词检索、筛选、收藏及关注等功能，以更好地匹配您的需求。您可以对您感兴趣的商品及/或服务进行收藏、添加至购物车，关注您所感兴趣的店铺/品牌等。<br>

    4.2 商品及/或服务的购买与评价<br>

    【商品及/或服务的购买】当您在助教科技平台购买商品及/或服务时，请您务必仔细确认所购商品的品名、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。<br>

    您的购买行为应当基于真实的消费需求，不得存在对商品及/或服务实施恶意购买、恶意维权等扰乱助教科技平台正常交易秩序的行为。基于维护助教科技平台交易秩序及交易安全的需要，助教科技发现上述情形时可主动执行关闭相关交易订单等操作。<br>

    【一口价与拍卖】助教科技平台存在“一口价”和“拍卖”两种出价形式。在拍卖形式下，您理解助教科技平台并非《中华人民共和国拍卖法》规定的“拍卖人”， 助教科技平台仅为用户以竞价形式购买商品及/或服务的在线交易场所。<br>

    【评价】您有权在助教科技平台提供的评价系统中对与您达成交易的其他用户商品及/或服务进行评价。您应当理解，您在助教科技平台的评价信息是公开的，如您不愿意在评价信息中向公众披露您的身份信息，您有权选择通过匿名形式发表评价内容。<br>

    为确保评价内容能为消费者购物决策提供可靠的依据，反映商品及/或服务的真实情况，您的所有评价行为应遵守助教科技平台规则的相关规定，评价内容应当合法、客观、真实，与交易的商品及/或服务具有关联性，且不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息；您不应以不正当方式帮助他人提升信用或利用评价权利对其他用户实施威胁、敲诈勒索。助教科技可按照助教科技平台规则的相关规定对您实施上述行为所产生的评价信息采取必要处置措施。<br>

    4.3 交易争议处理<br>

    【交易争议处理途径】您在助教科技平台交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：<br>

    （一）与争议相对方自主协商；<br>

    （二）使用助教科技平台提供的争议调处服务；<br>

    （三）请求消费者协会或者其他依法成立的调解组织调解；<br>

    （四）向有关行政部门投诉；<br>

    （五）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；<br>

    （六）向人民法院提起诉讼。<br>

    【平台调处服务】如您依据助教科技平台规则使用助教科技平台的争议调处服务，则表示您认可并愿意履行助教科技平台的客服或大众评审员（“调处方”）作为独立的第三方根据其所了解到的争议事实并依据助教科技平台规则所作出的调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等）。在助教科技平台调处决定作出前，您可选择上述（三）、（四）、（五）、（六）途径（下称“其他争议处理途径”）解决争议以中止助教科技平台的争议调处服务。<br>

    如您对调处决定不满意，您仍有权采取其他争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您仍应先履行调处决定。<br>

    4.4 信息交流<br>

    为满足用户间分享购物心得等信息交流需求，您可通过助教科技提供的问答、晒单分享、论坛、群组及其他信息发布功能进行评论、回复、留言、弹幕、点赞等公开发布信息及与其他用户互动，信息的形式包括文字、图片、视频、直播内容、表情、符号等，您须确保您所发布的所有信息均符合相关法律法规及本协议的要求。<br>

    4.5 贸易限制<br>

    针对通过助教科技平台取得的商品、服务、软件及技术（包括助教科技平台提供的软件及技术），您承诺遵守所有适用的进出口管制、贸易限制与经济制裁相关法律法规。基于维护助教科技平台交易秩序及交易安全的需要，如您违反前述承诺的，助教科技可在发现上述情形时主动执行关闭相关交易订单及作出账户处置等操作。<br>

    4.6 费用<br>

    助教科技为助教科技平台向您提供的服务付出了大量的成本，除助教科技平台明示的收费业务外，助教科技向您提供的服务目前是免费的。如未来助教科技向您收取合理费用，助教科技会采取合理途径并以足够合理的期限提前通过法定程序并以本协议第八条约定的方式通知您，确保您有充分选择的权利。<br>

    4.7 责任限制<br>

    【不可抗力及第三方原因】助教科技依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，助教科技并不承担相应的违约责任：<br>

    （一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；<br>

    （二）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；<br>

    （三）在助教科技已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。<br>

    【海量信息】助教科技仅向您提供助教科技平台服务，您了解助教科技平台上的信息系用户自行发布，且可能存在风险和瑕疵。助教科技将通过依法建立相关检查监控制度尽可能保障您在助教科技平台上的合法权益及良好体验。同时，鉴于助教科技平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，助教科技无法逐一审查商品及/或服务的信息，无法逐一审查交易所涉及的商品及/或服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断。<br>

    【调处决定】您理解并同意，在争议调处服务中，助教科技平台的客服、大众评审员并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，除存在故意或重大过失外，调处方对争议调处决定免责。<br>


    五、用户信息的保护及授权<br>

    5.1 个人信息的保护<br>

    助教科技非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用助教科技提供的服务时，您同意助教科技按照在助教科技平台上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。如阿里平台网站或客户端未设独立隐私权政策但使用了助教科技平台账号登陆相应网站或客户端的，为保护您的隐私权，我们将参照适用助教科技网隐私权政策的要求对您的个人信息进行收集、存储、使用、披露和保护。助教科技希望通过隐私权政策向您清楚地介绍助教科技对您个人信息的处理方式，因此助教科技建议您完整地阅读隐私权政策（点击此处），以帮助您更好地保护您的隐私权。<br>

    5.2 非个人信息的保证与授权<br>

    【信息的发布】您声明并保证，您对您所发布的信息拥有相应、合法的权利，您所发布的信息及实施的行为均符合相关法律法规、国家强制性标准要求及本协议约定，并且您对您发布的信息负有管理义务，对其中您违反相关法律法规规定及本协议约定的信息应立即删除。否则，助教科技可对您发布的信息依法或依本协议进行删除或屏蔽。<br>

    【禁止性信息】您应当确保您所发布的信息不包含以下内容：<br>

    （一）反对宪法所确定的基本原则的；<br>

    （二）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一，损害国家荣誉和利益的；<br>

    （三）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；<br>

    （四）煽动民族仇恨、民族歧视，破坏民族团结的；<br>

    （五）煽动地域歧视、地域仇恨、人群歧视的；<br>

    （六）破坏国家宗教政策，宣扬邪教和封建迷信的；<br>

    （七）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；<br>

    （八）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>

    （九）侮辱或者诽谤他人，侵害他人名誉、隐私、肖像、知识产权和其他合法权益的；<br>

    （十）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序的，破坏社会稳定的；<br>

    （十一）对他人进行暴力恐吓、威胁的；<br>

    （十二）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的，或侵害未成年人合法权益或者损害未成年人身心健康的；<br>

    （十三）侵害他人个人隐私的，未获他人允许，偷拍、偷录他人，侵害他人合法权利的；<br>

    （十四）散布过度营销信息及垃圾信息；<br>

    （十无）使用本网站常用语言文字以外的其他语言文字评论的；<br>

    （十六）所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；<br>

    （十七）使用夸张标题，内容与标题严重不符的；<br>

    （十八）炒作绯闻、丑闻、劣迹等的；<br>

    （十九）不当评述自然灾害、重大事故等灾难的；<br>

    （二十）宣扬低俗、庸俗、媚俗内容的或宣扬拜金炫富等不良内容的；<br>

    （二十一）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：自杀自残暴力行为的；威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容；怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；<br>

    （二十三）冒充他人或利用他人的名义使用助教科技软件服务或传播任何信息，恶意使用注册账号导致其他用户误认的；<br>

    （二十四）存在可能破坏、篡改、删除、影响助教科技平台任何系统正常运行或未经授权秘密获取助教科技平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；<br>

    （二十五）其他对网络生态造成不良影响的内容，及法律、行政法规禁止的其他内容。<br>

    【授权使用】对于您提供、发布及在使用助教科技平台服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，均不会因上传、发布等行为发生知识产权、肖像权等权利的转移，除非我们另行说明，在法律允许的范围内，您免费授予助教科技及其关联公司、无地域限制的许可使用（包括存储、使用、复制、修订、编辑、发布、展示、翻译、分发上述信息或制作派生作品，以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内等）及可再许可第三方使用的权利，以及可以自身名义对第三方侵权行为取证及提起诉讼的权利。<br>

    5.3 投诉、举报<br>

    如您在使用助教科技平台服务的过程中发现各类违法违规行为、违法传播活动、违法有害信息等内容，您可以通过“举报中心”“互联网违法和不良信息举报邮箱及助教科技平台公示的其他方式进行投诉、举报，助教科技将依据相关法律规定及时处理您的投诉举报。<br>


    六、用户的违约及处理<br>

    6.1 违约认定<br>

    发生如下情形之一的，视为您违约：<br>

    （一）使用助教科技平台服务时违反有关法律法规规定的；<br>

    （二）违反本协议或本协议补充协议（即本协议第2.2条）约定的。<br>

    为适应电子商务发展和满足海量用户对高效优质服务的需求，您理解并同意，助教科技可在助教科技平台规则中约定违约认定的程序和标准。如：助教科技可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。<br>

    6.2 违约处理措施<br>

    【信息处理】您在助教科技平台上发布的信息构成违约的，助教科技可根据相应规则立即对相应信息进行删除、屏蔽处理。<br>

    【行为限制】您在助教科技平台上实施的行为，或虽未在助教科技平台上实施但对助教科技平台及其用户产生影响的行为构成违约的，助教科技可依据相应规则对您执行账户扣分、中止向您提供部分或全部服务、划扣违约金等处理措施。如您的行为构成根本违约的，助教科技可查封您的账户，终止向您提供服务。<br>

    【账户处理】当您违约的同时存在欺诈、售假、盗用他人账户等特定情形或您存在危及他人交易安全或账户安全风险时，助教科技会依照您行为的风险程度指示公司对您的账户采取取消收款、资金止付等强制措施。<br>

    【处理结果公示】助教科技可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在助教科技平台上予以公示。<br>

    6.3 赔偿责任<br>

    如您的行为使助教科技及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿助教科技及/或其关联公司的上述全部损失。<br>

    如您的行为使助教科技及/或其关联公司遭受第三人主张权利，助教科技及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。<br>

    如因您的行为使得第三人遭受损失或您怠于履行调处决定、助教科技及/或其关联公司出于社会公共利益保护目的，可指示公司自您的账户中划扣相应款项进行支付。如您的余额或保证金不足以支付相应款项的，您同意委托助教科技使用自有资金代您支付上述款项，您应当返还该部分费用并赔偿因此造成助教科技的全部损失。<br>

    您同意助教科技指示公司自您的账户中划扣相应款项支付上述赔偿款项。如您账户中的款项不足以支付上述赔偿款项的，助教科技及/或关联公司可直接抵减您在助教科技及/或其关联公司其它协议项下的权益，并可继续追偿。<br>

    6.4 特别约定<br>

    【商业贿赂】如您向助教科技及/或其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，助教科技可立即终止与您的所有合作并向您收取违约金及/或赔偿金，该等金额以助教科技因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。<br>

    【关联处理】如您因严重违约导致助教科技终止本协议时，出于维护平台秩序及保护消费者权益的目的，助教科技及/或其关联公司可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以本协议第八条约定的方式通知您。<br>

    如助教科技与您签署的其他协议及助教科技及/或其关联公司、公司与您签署的协议中明确约定了对您在本协议项下合作进行关联处理的情形，则助教科技出于维护平台秩序的目的，可在收到指令时中止甚至终止协议，并以本协议第八条约定的方式通知您。<br>


    七、协议的变更<br>

    助教科技可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过法定程序并以本协议第八条约定的方式通知您。<br>

    如您不同意变更事项，您有权于变更事项确定的生效日前联系助教科技反馈意见。如反馈意见得以采纳，助教科技将酌情调整变更事项。<br>

    如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用助教科技平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用助教科技平台服务，则视为您同意已生效的变更事项。<br>


    八、通知<br>

    8.1 有效联系方式<br>

    您在注册成为助教科技平台用户，并接受助教科技平台服务时，您应该向助教科技提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。<br>

    您在注册助教科技平台用户时生成的用于登陆助教科技平台接收站内信、系统消息也作为您的有效联系方式。<br>

    助教科技将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。<br>

    您有权通过您注册时填写的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；您如果不愿意接收此类信息，您有权通过助教科技提供的相应的退订功能进行退订。<br>

    8.2 通知的送达<br>

    助教科技通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在助教科技平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送旺旺信息、系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。<br>

    对于在助教科技平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在助教科技平台注册、更新时提供的手机号码、电子邮箱联系方式以及在注册助教科技用户，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。<br>

    您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。<br>

    您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。<br>

    你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。<br>


    九、协议的终止<br>

    9.1 终止的情形<br>

    【用户发起的终止】您有权通过以下任一方式终止本协议：<br>

    （一）在满足助教科技平台公示的账户注销条件（您可通过“助教科技APP-我的助教科技-设置-账号与安全-注销账号”查看具体账户注销条件）时您通过网站自助服务注销您的账户的；<br>

    （二）变更事项生效前您停止使用并明示不愿接受变更事项的；<br>

    （三）您明示不愿继续使用助教科技平台服务，且符合助教科技平台终止条件的。<br>

    【助教科技发起的终止】出现以下情况时，助教科技可以本协议第八条的所列的方式通知您终止本协议：<br>

    （一）您违反本协议约定，助教科技依据违约条款终止本协议的；<br>

    （二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，助教科技依据助教科技平台规则对您的账户予以查封的；<br>

    （三）除上述情形外，因您多次违反助教科技平台规则相关规定且情节严重，助教科技依据助教科技平台规则对您的账户予以查封的；<br>

    （四）您的账户被助教科技依据本协议回收的；<br>

    （五）您在或阿里平台有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；<br>

    （六）其它应当终止服务的情况。<br>

    9.2 协议终止后的处理<br>

    【用户信息披露】本协议终止后，除法律有明确规定外，助教科技无义务向您或您指定的第三方披露您账户中的任何信息。<br>

    【助教科技权利】本协议终止后，助教科技仍享有下列权利：<br>

    （一）继续保存您留存于助教科技平台的本协议第五条所列的各类信息；<br>

    （二）对于您过往的违约行为，助教科技仍可依据本协议向您追究违约责任。<br>

    【交易处理】本协议终止后，对于您在本协议存续期间产生的交易订单，助教科技可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。<br>


    十、法律适用、管辖与其他<br>

    【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。<br>

    【管辖】您因使用助教科技平台服务所产生及与助教科技平台服务有关的争议，由助教科技与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。<br>

    【可分性】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。<br>


  </div>
</template>

<script>
export default {
  name: "LegalAgree"
}
</script>

<style scoped>

</style>
